import { Column } from 'react-table'
import GetUrls from 'ts/enums/Url'
import { User } from 'ts/types/User'
import { Boolean as BooleanCell } from 'components/ui'
import CardTable from 'components/CardTable'
import UserAddPage from './UserAddPage'
import { useTrader } from 'context/TraderTypeContext'

const UserPage = () => {
  const Url = GetUrls();
  const { traderId } = useTrader();
  console.log("UsersPage TraderId:", traderId)

  const columns: Column<User>[] = [
    {
      Header: 'ID',
      accessor: 'programUserId'
    },
    {
      Header: 'Active',
      accessor: 'flActive',
      Cell: ({ value }) => <BooleanCell value={value} />
    },
    {
      Header: 'Name',
      accessor: 'name'
    },
    {
      Header: 'Login',
      accessor: 'login'
    },
    {
      Header: 'E-mail',
      accessor: 'emailAddress'
    },
    {
      Header: '',
      accessor: 'userTypeId',
      Cell : ''
    },
    {
      Header: '',
      accessor: 'invalidLogins',
      Cell: ''
    },
    {
      Header: '',
      accessor: 'password',
      Cell: ''
    },
  ]
  return (
  <CardTable
    columns={columns}
    dataKey={Url.getUser.toString()}
    url={Url.getUser(traderId)}
    modalChild={<UserAddPage />}
  />
)}

export default UserPage
